import React from "react";
import { Controller } from "react-hook-form";
import { FBasicPropos } from "../../../interfaces/User.interface";
import { InputAdornment, TextField } from "@mui/material";

export const FTextField: React.FC<FBasicPropos> = ({
    field,
    control,
    errors,
    errorMessage
}) => {
    const { name, editable, icon, inputProps, props, onChange } = field;
    if (!errorMessage) errorMessage = errors[name]?.message as string;

    return (
        <Controller
            name={name}
            control={control}
            // defaultValue={preFilled ? preFilled : (defaultValue ? defaultValue : undefined)}
            render={({ field: controllerField }) => {
                const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
                    if (onChange) {
                        onChange(event); // Custom onChange logic
                    }
                    controllerField.onChange(event); // Default react-hook-form onChange
                };

                return (
                    <TextField
                        {...controllerField}
                        label={field.question}
                        variant="standard"
                        margin="normal"
                        fullWidth
                        error={!!errors[name] || !!errorMessage}
                        helperText={errorMessage}
                        disabled={editable === false}
                        placeholder={field.question}
                        InputProps={{
                            startAdornment: icon && (
                                <InputAdornment position="start">
                                    {icon}
                                </InputAdornment>
                            ),
                            ...inputProps
                        }}
                        {...props}
                        onChange={handleChange}
                        // required
                        // required={field.required}
                    />
                );
            }}
        />
    );
};
